export enum ProfessionalActivity {
  EMPLOYEE = 'employee',
  INDEPENDENT = 'independant',
  STUDENT = 'student',
  UNEMPLOYED = 'unemployed',
  INCAPACITATED = 'incapacitated',
  RETIRED = 'retired',
}

export const professionalActivityMapping = {
  [ProfessionalActivity.EMPLOYEE]: $localize`:@@common_professionalActivity_employee:Employee`,
  [ProfessionalActivity.INDEPENDENT]: $localize`:@@common_professionalActivity_independant:Independant`,
  [ProfessionalActivity.STUDENT]: $localize`:@@common_professionalActivity_student:Student`,
  [ProfessionalActivity.UNEMPLOYED]: $localize`:@@common_professionalActivity_unemployed:Unemployed`,
  [ProfessionalActivity.INCAPACITATED]: $localize`:@@common_professionalActivity_incapacited:Incapacited`,
  [ProfessionalActivity.RETIRED]: $localize`:@@common_professionalActivity_retired:Retired`,
};
